<template>
  <px-lateral-dialog v-model="dialog"
                     width="600">
    <template v-slot:activator="{ on }">
      <v-btn color="primary"
             class="normal-btn-text rounded-tag-small elevation-0"
             v-on="on">
        Alterar Senha
      </v-btn>
    </template>
    <template v-slot:title>
      Alterar senha
    </template>
    <form autocomplete="off">
      <!--  fake fields are a workaround for chrome/opera autofill getting the wrong fields -->
      <input id="password" style="display:none" type="password"
             name="fakepasswordremembered">
      <input id="password" style="display:none" type="password"
             name="fakepasswordremembered">
      <input id="matchPassword" style="display:none" type="password"
             name="fakepasswordremembered">
      <v-row dense>
        <v-col cols="12">
          Insira a sua senha atual:
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            outlined
            label="Senha atual"
            class="required rounded-tag-small"
            minlength="8"
            maxlength="30"
            autocomplete="off"
            hide-details
            :type="passwordType(showCurrentPassword)"
            :append-icon="passwordIcon(showCurrentPassword)"
            @click:append="onClickShowCurrentPassword()"
            :error="$v.currentPassword.$error"
            @blur="$v.currentPassword.$touch()"
            v-model="currentPassword"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          Insira a nova senha e a confirmação:
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            outlined
            label="Nova senha"
            class="required rounded-tag-small"
            minlength="8"
            maxlength="30"
            :messages="passwordMessages"
            autocomplete="off"
            :type="passwordType(showNewPassword)"
            :append-icon="passwordIcon(showNewPassword)"
            @click:append="onClickShowNewPassword()"
            :error="$v.newPassword.$error"
            @blur="$v.newPassword.$touch()"
            v-model="newPassword"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            outlined
            hide-details
            label="Repetir senha"
            class="required rounded-tag-small"
            minlength="8"
            maxlength="30"
            autocomplete="off"
            :type="passwordType(showMatchPassword)"
            :append-icon="passwordIcon(showMatchPassword)"
            @click:append="onClickShowMatchPassword()"
            :error="$v.matchPassword.$error"
            @blur="$v.matchPassword.$touch()"
            v-model="matchPassword"
          />
        </v-col>
      </v-row>
    </form>
    <template>
    </template>
    <template v-slot:actions>
      <v-spacer/>
      <v-btn @click="close" class="normal-btn-text rounded-tag-small elevation-0">
        Cancelar
      </v-btn>
      <v-btn color="primary"
             class="normal-btn-text rounded-tag-small elevation-0"
             :disabled="$v.$invalid"
             :loading="loading"
             @click="alterarSenha"
      >
        Salvar
      </v-btn>
    </template>
  </px-lateral-dialog>
</template>
<script>
import {
  maxLength, minLength, required, sameAs,
} from 'vuelidate/lib/validators';
import { isPasswordValid } from '@/utils/validate-password';
import PasswordService from '@/modules/login/alterar-senha/password-service';
import { LOGOUT } from '@/store/auth/actions.type';

export default {
  data() {
    return {
      dialog: false,
      loading: false,
      showCurrentPassword: false,
      showNewPassword: false,
      showMatchPassword: false,
      currentPassword: null,
      newPassword: null,
      matchPassword: null,
      passwordMessages: ['Deve possuir letra maiúscula, minúscula e números. Entre 8 e 30 caracteres'],
    };
  },
  computed: {
    passwordType() {
      return (show) => {
        if (show) {
          return 'text';
        }
        return 'password';
      };
    },
    passwordIcon() {
      return (show) => {
        if (show) {
          return 'mdi-eye-off';
        }
        return 'mdi-eye';
      };
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    alterarSenha() {
      this.loading = true;
      PasswordService.changePassword(this.buildBody())
        .then(() => {
          this.close();
          this.$toast.success('Senha alterada');
          this.$store.dispatch(LOGOUT)
            .finally(() => this.$router.push({ name: 'login' }));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildBody() {
      return {
        password: this.currentPassword,
        newPassword: this.newPassword,
        matchPassword: this.matchPassword,
      };
    },
    onClickShowCurrentPassword() {
      this.showCurrentPassword = !this.showCurrentPassword;
    },
    onClickShowNewPassword() {
      this.showNewPassword = !this.showNewPassword;
    },
    onClickShowMatchPassword() {
      this.showMatchPassword = !this.showMatchPassword;
    },
  },
  watch: {
    dialog(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (newValue) {
        this.currentPassword = null;
        this.newPassword = null;
        this.matchPassword = null;
        this.$v.$reset();
      }
    },
  },
  validations: {
    currentPassword: {
      required,
      minLength: minLength(8),
    },
    newPassword: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(30),
      passwordValid(value) {
        return isPasswordValid(value);
      },
    },
    matchPassword: {
      required,
      sameAsPassword: sameAs('newPassword'),
    },
  },
};
</script>
